import {
  getMembersFromRootMember,
  getMembersFromMembers,
  getCommitsFromMembers
} from './tactonService';
import HttpService from './http.service';

import axios from 'axios';

const allSegmentsForCADXML = startData => {
  var allStations = startData?.segmentStep.rootGroup.members.filter(
    x => x.name.includes('segment') && x.hasVisibleParameters
  );
  return allStations;
};

const generateCADXMLforManifold = async (startData, sessionData) => {
  var availableSteps = startData.tactonModel.steps.filter(
    x =>
      x.available == true &&
      !x.name.includes('initial_step') &&
      !x.name.includes('order_summary')
  );
  var stepRootGroupMembers = [];
  var stepRootUIGroupMembers = [];
  var parentSelectionMembers = [];
  var uiMembers;
  var internalMembers = [];
  var infoMembers;
  var parentChildSelection = { divisionID: '', series: '', configurators: [] };
  var configurators = [];
  var config;
  var parentConfig;
  var configSelection;
  var configPartNumber;
  var hseriesDash;
  var parentConfigNumber;
  parentChildSelection.divisionID = sessionData.manufacturingLocation;
  parentChildSelection.series = sessionData.configModel; //"H SERIES UNIV ADD-A-FOLD";
  for (let step of availableSteps) {
    parentSelectionMembers = [];
    configSelection = [];
    config = {
      configuratorType: '',
      childSeriesName: '',
      partNumber: '',
      componentSelections: []
    };
    if (step.name.includes('manifold')) {
      stepRootGroupMembers = step.rootGroup.members.filter(
        x =>
          x.name.includes('ui_group') &&
          (!x.properties || x.properties['hidden'] != 'yes')
      );

      stepRootUIGroupMembers = step.rootGroup.members.filter(
        x =>
          x.name.includes('info_group') &&
          (!x.properties || x.properties['hidden'] != 'yes')
      );

      config.configuratorType = 'ASSEMBLY';
      if (stepRootGroupMembers.length > 0) {
        uiMembers = getMembersFromRootMember(stepRootGroupMembers[0]);
        uiMembers = uiMembers.filter(
          x => !x.properties || x.properties['hidden'] != 'yes'
        );

        if (stepRootUIGroupMembers.length > 0) {
          hseriesDash = stepRootUIGroupMembers[0].members.filter(
            x =>
              x.name.includes('dash_field') &&
              (!x.properties || x.properties['hidden'] != 'yes')
          );
          if (hseriesDash.length > 0) uiMembers.push(hseriesDash[0]);
        }

        configSelection = addConfigSelection(uiMembers);
        config.componentSelections = configSelection;
        configurators.push(config);
      }
    } else if (step.name.includes('segment')) {
      //get the manifold info group from segement step to get the parent part number
      stepRootGroupMembers = step.rootGroup.members.filter(
        x =>
          x.properties &&
          x.properties['info_group'] == 'yes' &&
          x.properties['hidden'] != 'yes'
      );
      // config.configuratorType = "VALVE";
      if (stepRootGroupMembers.length > 0) {
        configPartNumber = stepRootGroupMembers[0].members.filter(
          x => x.properties['ph_order_code_legacy'] == 'yes'
        );
        if (configPartNumber.length > 0) {
          parentConfig = configurators.find(
            x => x.configuratorType == 'ASSEMBLY'
          );
          parentConfig.partNumber = configPartNumber[0].value;
          parentConfig.bomDesc = configPartNumber[0].description;
          parentConfigNumber = configPartNumber[0].value;
        }
      }
      var allStations = allSegmentsForCADXML(startData);

      for (let segment of allStations) {
        if (!segment.name.includes('segment_init')) {
          config = {
            configuratorType: '',
            childSeriesName: '',
            partNumber: '',
            componentSelections: [],
            bomDesc: ''
          };
          config.configuratorType = 'VALVE';
          //get the segment info members to get the segment valve part number
          infoMembers = currentSegmentInfoMembers(segment);
          if (infoMembers.length > 0) {
            configPartNumber = infoMembers.filter(
              x => x.properties['ph_order_code_legacy'] == 'yes'
            );
            if (configPartNumber.length > 0) {
              config.partNumber = configPartNumber[0].value;
              config.bomDesc = configPartNumber[0].description;
            }
          }
          //get the segment series members selections
          var uiGroup = currentSegmentSeriesGroup(segment);
          if (uiGroup.length > 0) {
            // var index = uiGroup[0].description.lastIndexOf('-');
            // if (index > 0)
            // config.childSeriesName = uiGroup[0].description
            //   .substring(0, index)
            //   .trim();
            config.childSeriesName = uiGroup[0].description;
            uiMembers = getMembersFromMembers(uiGroup[0]);
            internalMembers = uiMembers.filter(
              x =>
                x.properties['ph_internal_field'] &&
                x.properties['ph_internal_field'] != ''
            );
            uiMembers = uiMembers.filter(
              x => !x.properties || x.properties['hidden'] != 'yes'
            );
            if (internalMembers.length > 0) {
              for (let internalMember of internalMembers) {
                if (
                  uiMembers.filter(x =>
                    x.name.includes(
                      internalMembers[0].properties['ph_internal_field'] + '_'
                    )
                  ).length > 0
                )
                  uiMembers.push(internalMember);
              }
            }
            configSelection = addConfigSelection(uiMembers);
            config.componentSelections = configSelection;
            configurators.push(config);
          }
        }
        parentSelectionMembers = currentSegmentSelectionMembers(segment);
        if (parentSelectionMembers.length > 0) {
          configSelection = [];
          parentSelectionMembers = parentSelectionMembers.filter(
            x => !x.properties || x.properties['hidden'] != 'yes'
          );
          configSelection = addConfigSelection(parentSelectionMembers);
          parentConfig = configurators.find(
            x => x.configuratorType == 'ASSEMBLY'
          );
          parentConfig.componentSelections.push(...configSelection);
        }
      }
      config.configuratorType = 'VALVE';
    }
  }
  parentConfig.partNumber = parentConfigNumber;
  parentChildSelection.configurators = configurators;

  let response;
  await HttpService.postByObject('cad/GetManifoldCADXML', parentChildSelection)
    .then(res => {
      response = res.data;
    })
    .catch(error => {
      console.log(error);
    });

  return response;
};

const addConfigSelection = uiMembers => {
  var selection;
  var configSelection = [];
  var index = -1;
  for (let member of uiMembers) {
    selection = {
      componentValue: '',
      componentValueDescription: '',
      componentModelValue: '',
      isPartNumber: false
    };
    if (member.domain.name.endsWith('class')) {
      selection.componentValue = member.value;
    } else {
      //to remove the last digit for repeated field names in the segments 1 to 32
      if (member.name.includes('_field_')) {
        index = member.name.lastIndexOf('_');
        selection.componentValue = member.name.substring(0, index);
      } else {
        selection.componentValue = member.name;
      }
      selection.componentModelValue = member.valueDescription;
    }
    //set the model value if the control is part number control that is added to parent
    if (member.properties && member.properties['ph_add_to_parent'] == 'yes') {
      selection.componentModelValue = member.valueDescription;
      selection.isPartNumber = true;
    }
    selection.componentValueDescription = member.valueDescription;
    configSelection.push(selection);
  }
  return configSelection;
};

//To get segment info Group
const currentSegmentInfoMembers = segment => {
  var segmentinfoMemberGroup = segment.members.filter(
    x =>
      x.name.includes('info_group') &&
      (!x.properties || x.properties['hidden'] != 'yes')
  );
  if (segmentinfoMemberGroup.length <= 0) return segmentinfoMemberGroup;
  var seriesInfoGroup = segmentinfoMemberGroup[0].members.filter(
    x => !x.properties || x.properties['hidden'] != 'yes'
  );
  var infoMembers = getMembersFromMembers(seriesInfoGroup[0]);

  return infoMembers.filter(
    x => !x.properties || x.properties['hidden'] != 'yes'
  );
};
//To get segment selection members
const currentSegmentSelectionMembers = segment => {
  var segmentSelectionGroup = segment.members.filter(x =>
    x.name.includes('selection')
  );
  if (segmentSelectionGroup.length <= 0) return segmentSelectionGroup;
  return getMembersFromMembers(segmentSelectionGroup[0]);
};

const currentSegmentSeriesGroup = segment => {
  var seriesUIGroup = [];
  if (segment) {
    var segmentUIMemberGroup = segment?.members.filter(
      x =>
        x.name.includes('ui_group') &&
        (!x.properties || x.properties['hidden'] != 'yes')
    );
    if (segmentUIMemberGroup.length <= 0) return seriesUIGroup;

    seriesUIGroup = segmentUIMemberGroup[0]?.members.filter(
      x => !x.properties || x.properties['hidden'] != 'yes'
    );
  }
  return seriesUIGroup;
};
const currentSegmentcommitedUIMembers = segment => {
  var seriesUIGroup = currentSegmentSeriesGroup(segment);
  if (seriesUIGroup.length <= 0) return seriesUIGroup;
  return getCommitsFromMembers(seriesUIGroup[0]);
};

//get the current segment series selection from previous segment group
const currentSegmentSeriesSelectionMember = segment => {
  var selectionMemberGroup = currentSegmentSelectionMembers(segment);
  //return current segment series selection
  return selectionMemberGroup?.filter(
    x =>
      x.properties != undefined && x.properties['ph_series_selection'] == 'yes'
  )[0];
};

//get commited UI group Members
const commitedUIMembers = segment => {
  var seriesUIGroup = getSegmentSeriesUIGroup(segment);
  if (seriesUIGroup.length == 0) return seriesUIGroup;
  return getCommitsFromMembers(seriesUIGroup[0]);
};

//get child series UI group
const getSegmentSeriesUIGroup = segment => {
  var segmentUIMemberGroup;
  segmentUIMemberGroup = getSegmentUIGroupMember(segment);
  if (!segmentUIMemberGroup || segmentUIMemberGroup.length <= 0)
    return segmentUIMemberGroup;
  return segmentUIMemberGroup[0].members.filter(
    x => !x.properties || x.properties['hidden'] != 'yes'
  );
};

const getSegmentUIGroupMember = segment => {
  var segmentUIMemberGroup = segment?.members?.filter(
    x =>
      x.name.includes('ui_group') &&
      (x.properties == undefined || x.properties['hidden'] != 'yes')
  );
  return segmentUIMemberGroup;
};
//get child series UI Group members
const getSegmentSeriesUIMembers = segment => {
  var seriesUIGroup = getSegmentSeriesUIGroup(segment);
  if (seriesUIGroup) return getMembersFromMembers(seriesUIGroup[0]);
  else return [];
};

//To get segment display members
const currentSegmentSeriesMembers = segment => {
  var seriesUIGroup = currentSegmentSeriesGroup(segment);
  return getMembersFromMembers(seriesUIGroup[0]);
};

const assignEditedSegmentMember = (
  key,
  oldValue,
  segmentName,
  response,
  editedStationMembers
) => {
  var editedStationMember = { name: '', value: '', iscommit: false };
  //get selection group members from prev segment group

  var currentSegmentRootGroupIndex =
    response.segmentStep.rootGroup.members.findIndex(x =>
      x.name.includes(segmentName)
    );
  var currentStationMembers = currentSegmentSelectionMembers(
    response.segmentStep.rootGroup.members[currentSegmentRootGroupIndex - 1]
  );

  //get segment series members
  currentStationMembers.push(
    ...currentSegmentSeriesMembers(
      response.segmentStep.rootGroup.members[currentSegmentRootGroupIndex]
    )
  );

  var currentMember = currentStationMembers.filter(x => x.name == key);
  if (oldValue == '') {
    oldValue = currentMember[0].domain.elements.filter(
      x => x.selected == true
    )[0].name;
  }
  if (editedStationMembers?.filter(x => x.name == key).length == 0) {
    editedStationMember.name = key;
    editedStationMember.value = oldValue;
    editedStationMember.iscommit = currentMember[0].committed;
  }
  return editedStationMember;
};

//get the segment members of commit values
const getCommitsForSegment = (segmentName, commits, response) => {
  var allStationMembers = [];
  var commitingMembers = [];
  var selectionMembers = [];
  //Get segement selection members
  selectionMembers = currentSegmentSelectionorSeriesUIMembers(
    segmentName,
    'selection',
    response
  );
  //Get members of the specific segment UI members
  if (!segmentName.includes('segment_init')) {
    allStationMembers = currentSegmentSelectionorSeriesUIMembers(
      segmentName,
      'ui_group',
      response
    );
  }
  allStationMembers.push(...selectionMembers);
  commitingMembers = getCommitItemsforSegment(allStationMembers, commits);
  return commitingMembers;
};
const getCommitItemsforSegment = (allMembers, commitMembers) => {
  var commitingMemberArr = [];
  var data = [];
  var commitMember;
  for (var j = 0; j < commitMembers.length; j++) {
    data = allMembers.filter(x => x.name.includes(commitMembers[j].key));
    commitMember = new Object();
    commitMember['key'] = data[0].name;
    commitMember['value'] = commitMembers[j].value;
    commitingMemberArr.push(commitMember);
  }
  return commitingMemberArr;
};

//To get segment selection or UI members
const currentSegmentSelectionorSeriesUIMembers = (
  segmentName,
  groupName,
  response
) => {
  var segmentRootGroup = response.segmentStep.rootGroup.members.filter(
    x => x.name == segmentName
  );
  if (segmentRootGroup.length == 0) return;
  var segmentUIMemberGroup = segmentRootGroup[0].members.filter(x =>
    x.name.includes(groupName)
  );
  if (segmentUIMemberGroup.length > 0)
    return getMembersFromMembers(segmentUIMemberGroup[0]);
};

const getCADUrl = async (divisionId, partNumber) => {
  let cadDetails;
  await HttpService.getById(
    'controller/GetCADUrl',
    '?DivisionId=' + divisionId + '&Partnumber=' + partNumber
  )
    .then(res => {
      if (res.data) {
        cadDetails = res.data;
      }
    })
    .catch(error => console.log(error));
  return cadDetails;
};

const isValidPartNumber = async (miscURL, baseUrl) => {
  let result;
  if (!baseUrl) return false;
  var response = await axios.get(`${miscURL}`);
  if (response?.data) {
    return !response.data.error;
  } else return false;
};

const getMidentProjectName = async configModel => {
  let response = await HttpService.getAll(
    '/Cad/GetMident?configModel=' + configModel
  );
  return response?.data;
};

export {
  generateCADXMLforManifold,
  currentSegmentcommitedUIMembers,
  currentSegmentSeriesSelectionMember,
  commitedUIMembers,
  getSegmentSeriesUIGroup,
  getSegmentSeriesUIMembers,
  getSegmentUIGroupMember,
  currentSegmentSeriesGroup,
  assignEditedSegmentMember,
  currentSegmentSelectionMembers,
  getCommitsForSegment,
  getCommitItemsforSegment,
  currentSegmentSeriesMembers,
  getCADUrl,
  isValidPartNumber,
  getMidentProjectName
};
